import * as React from 'react';
import { SearchOff } from '@mui/icons-material';
import { TNotFoundDisplay } from './NotFoundDisplay.types';
import './NotFoundDisplay.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const NotFoundDisplay: TNotFoundDisplay = ({ title, text }) => {
  const localize = useLocalize();
  const displayTitle = title ?? localize('products.not.found.title');
  const displayText = text ?? localize('products.not.found.description');

  return (
    <div className="not-found-display">
      <SearchOff className="not-found-display__icon" />
      <h3 className="not-found-display__title">{displayTitle}</h3>
      <p className="not-found-display__text">{displayText}</p>
    </div>
  );
};
